export default __webpack_public_path__ + "static/media/016-snow.dd63e444.svg";